export const CARD_BASIS_CLASSNAMES =
  'basis-[calc(83.333%-8px)] w-[calc(83.333%-8px)] tablet:basis-[calc(50%-8px)] tablet:w-[calc(50%-8px)]';

export const CARD_PADDING_CLASSNAMES = 'p-0 first-of-type:pl-0 last-of-type:pr-0';

export const SLIDE_CONTAINER_CLASSNAMES =
  '-mx-4 max-w-none scroll-pl-4 gap-4 px-4 py-5 -my-5 tablet:mx-0 tablet:max-w-full tablet:scroll-pl-0 tablet:px-0';
